import styled from "styled-components";
import {styledByDevice} from "../../../../../themes/architecture/styled-by-device";

const DefaultBox = styled.ul`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

const PcBox = styled(DefaultBox)`
  float: left;
`;

const MobileBox = styled(DefaultBox)`
  margin: 1rem 0;
  padding: 0.5rem 0;
  background: ${props => props.theme.colors.background};
  border-radius: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LanguageSwitcherListDefaultBox = styledByDevice(PcBox, MobileBox);

